/**
 * ScrollEdgeBottom — sticky bottom container with glass blur + mask fade.
 * Suitable for primary CTA placement.
 * Atom purity: imports only react + tokens.
 */
import { CSSProperties, ReactNode } from 'react';
import { P } from '../../styles/tokens';

export interface ScrollEdgeBottomProps {
  children: ReactNode;
  style?: CSSProperties;
  /** Height of the fade zone. Default 110. */
  height?: number;
  /** Base color of the gradient fade. Defaults to P.cream. */
  bg?: string;
}

export function ScrollEdgeBottom({
  children,
  style,
  height = 110,
  bg = P.cream,
}: ScrollEdgeBottomProps) {
  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        height,
        pointerEvents: 'none',
        zIndex: 5,
        ...style,
      }}
    >
      {/* Glass blur + gradient fill */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backdropFilter: 'blur(14px) saturate(160%)',
          WebkitBackdropFilter: 'blur(14px) saturate(160%)',
          background: `linear-gradient(to top, ${bg} 0%, ${bg} 35%, transparent 100%)`,
          maskImage: 'linear-gradient(to top, black 50%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to top, black 50%, transparent 100%)',
        }}
      />
      {/* Content — pointer-events re-enabled for interactive children */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          pointerEvents: 'auto',
          padding: '0 16px 24px',
        }}
      >
        {children}
      </div>
    </div>
  );
}
